import {
  AnimatedContainer,
  AnimatedPage,
  AnimatedPageHeader,
  AnimatedSection
} from '@components/index'
import { Loader } from '@components/loader/Loader'
import { useTickets } from '@services/tickets/queries/useTickets'
import { MessageSquare, Wrench } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Card } from '@/components/ui/card'

import { TicketCreateDialog } from '../../components/TicketCreateDialog'
import { TicketPriorityPill, TicketStatusPill } from '../../components/TicketPills'
import { useIntlLocale } from '@/i18n/languages'

export function Tickets() {
  const { t } = useTranslation('tickets')
  const { data, isLoading } = useTickets()
  const locale = useIntlLocale()

  const tickets = data?.results ?? []

  return (
    <AnimatedPage>
      <div className="mx-auto w-full max-w-[900px] space-y-6">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <AnimatedPageHeader title={t('title')} description={t('subtitle')} />
          <TicketCreateDialog />
        </div>

        {isLoading ? (
          <Loader />
        ) : tickets.length === 0 ? (
          <Card className="flex flex-col items-center gap-3 p-10 text-center">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
              <Wrench className="h-6 w-6" />
            </span>
            <p className="m-0 font-medium text-ink">{t('empty.title')}</p>
            <p className="m-0 text-sm text-muted-foreground">
              {t('empty.subtitle')}
            </p>
          </Card>
        ) : (
          <AnimatedContainer>
            <div className="space-y-3">
              {tickets.map((ticket) => (
                <AnimatedSection key={ticket.id}>
                  <Link
                    to={`/user/tickets/${ticket.id}`}
                    className="flex items-center justify-between gap-4 rounded-2xl border border-ink/[0.06] bg-white p-4 shadow-sm transition-shadow hover:shadow-md"
                  >
                    <div className="min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="truncate font-semibold text-ink">
                          {ticket.title}
                        </span>
                        <TicketStatusPill status={ticket.status} />
                        <TicketPriorityPill priority={ticket.priority} />
                      </div>
                      <div className="mt-1 text-xs text-muted-foreground">
                        {t(`categories.${ticket.category}`)}
                        {' · '}
                        {new Date(ticket.created_at).toLocaleDateString(locale)}
                      </div>
                    </div>
                    <span className="flex shrink-0 items-center gap-1.5 text-sm text-muted-foreground">
                      <MessageSquare className="h-4 w-4" />
                      {ticket.comments_count}
                    </span>
                  </Link>
                </AnimatedSection>
              ))}
            </div>
          </AnimatedContainer>
        )}
      </div>
    </AnimatedPage>
  )
}
